export const phoneMask = '+9 (999) 999 99 99';
